/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react'
import { Form, FormInstance, Row, Select, Space } from 'antd'
import SelectSearch from '../SelectSearch'

interface UserValue {
  label: string
  value: number
}

interface InputCompatibi {
  cod: number
  array: { label: string; value: number }[]
  onChange: (value: number) => void
  onSearch?: (value: number) => void
  fetchOptions: (search: string, codSelect: number) => Promise<UserValue[]>
  form: FormInstance
  disabled?: boolean
  onInputName?: (nameInput: string) => void
  disableTipo?: boolean
}

export const InputsCompatibilidade: React.FC<InputCompatibi> = ({
  cod,
  array,
  onChange,
  onSearch,
  fetchOptions,
  form,
  disabled,
  onInputName,
  disableTipo = false,
}) => {
  const [codSelect, setCodSelect] = useState(0)
  const input: { name: string; label: string } = {
    name: '',
    label: '',
  }
  let empty = ''
  switch (cod) {
    case 1:
      input.label = 'Selecione o insumo'
      input.name = 'cod_insumo'
      empty = 'Insumo'
      break
    case 2:
      input.label = 'Selecione o ingrediente ativo'
      input.name = 'cod_ingrediente_ativo'
      empty = 'Ingrediente ativo'

      break
    case 3:
      input.label = 'Selecione o grupo químico'
      input.name = 'cod_grupo_quimico'
      empty = 'Grupo químico'

      break
    case 4:
      input.label = 'Selecione a cultura'
      input.name = 'cod_cultura'
      empty = 'Cultura'

      break
    case 5:
      input.label = 'Selecione a tecnologia'
      input.name = 'cod_tecnologia'
      empty = 'Tecnologia'

      break
    default:
      input.label = 'Selecione um tipo para iniciar'
      input.name = ''
      empty = ''
  }

  const handleChange = (value: number) => {
    onChange(value)
  }

  const handleSearch = (value: number) => {
    onSearch?.(value)
  }

  useEffect(() => {
    setCodSelect(cod === undefined ? 0 : cod)
  }, [cod])
  return (
    <Row>
      <Space>
        <Form.Item style={{ width: '275px' }} label='Selecione um tipo' name='tipo'>
          <Select
            disabled={disableTipo}
            allowClear
            defaultValue={null}
            onClear={() => setCodSelect(0)}
            onChange={handleChange}
            options={array}
          />
        </Form.Item>
        <Form.Item style={{ width: '275px' }} {...input}>
          <SelectSearch
            empty={empty}
            disabled={disabled}
            fetchOptions={(search) => fetchOptions(search, codSelect)}
            onChange={(data) => {
              handleSearch(data?.value)
              form.setFieldsValue({ [`${input.name}`]: data?.value })
              onInputName(input?.name)
            }}
          />
        </Form.Item>
      </Space>
    </Row>
  )
}
